module.exports = __webpack_public_path__ + "images/assets/34c5fceeae59632758c210999f19efc4.svg";